import { useEffect } from 'react'

import { PAGES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'

import { useActiveMicrositesMetadataList } from './useActiveMicrositesMetadataList'
import { routeToPageMap } from '../constants/mixpanelConstants'

export const useUpdateRouteToPageMap = () => {
  const activeMicrositesMetadataList = useActiveMicrositesMetadataList()

  useEffect(() => {
    activeMicrositesMetadataList.forEach((item) => {
      routeToPageMap[`/${item.micrositeUrl}`] = item.page as PAGES
    })
  }, [activeMicrositesMetadataList])
}
